import { Component, Input, Output, AfterViewInit, OnDestroy, EventEmitter } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { AppService } from 'src/app/app.service';
import { DialogsService } from 'src/app/_services/dialogs.service';
import { OrderService } from 'src/app/_services/order.service';
import { OrderItemsUtilsService } from '../order-items-util.service';
import { OrderItemsDialogsService } from '../order-items-dialogs.service';
import { OfferSearchDialogComponent } from '../offer-search-dialog/offer-search-dialog.component';
import { ChatSearchDialogComponent } from 'src/app/chat-bot/chat-search-dialog/chat-search-dialog.component';

import * as _ from 'lodash';
import {TabitPayService} from "../../tabit-pay/tabit-pay.service";
import {ComponentType} from "@angular/cdk/overlay";
declare const $: any;

@Component({
    selector: 'app-menu',
    templateUrl: './menu.component.html',
    styleUrl: './menu.component.scss',
    standalone: false
})
export class MenuComponent implements AfterViewInit, OnDestroy {
	@Input() options: any = {}
	@Output() checkout: any = new EventEmitter();
	@Output() onloyalty: any = new EventEmitter();

	$storage: any;
	offerDiners

	constructor(
		public appService: AppService,
		public dialog: MatDialog,
		public dialogsService: DialogsService,
		public orderService: OrderService,
		public orderUtils: OrderItemsUtilsService,
		public orderDialogs: OrderItemsDialogsService,
		public tabitPayService: TabitPayService,
	) {
		this.$storage = this.orderService.$storage;
		let offerDiners = {}
		_.each(this.tabitPayService.$storage?.order?.offerDiners || {}, (val, key) => {
			offerDiners[key.split('_')[0]] = val;
		});
		this.offerDiners = offerDiners;
		console.log("offerDiners", this.offerDiners);
	}

	onLoyalty(){
		this.onloyalty.emit(true);
	}

	observer: IntersectionObserver;
	ngAfterViewInit(ev?) {
		/*
		const el = document.querySelector(".categories-header")
		this.observer = new IntersectionObserver(([e]) => {
			e.target.classList.toggle("_pinned", e.intersectionRatio < 1)
		},
			{ threshold: [1] }
		);
		this.observer.observe(el);
		*/
	}

	ngOnDestroy(ev?) {
		//this.observer.unobserve;
	}

	menuItemClick(obj, ev?) {
		if (ev) ev.stopPropagation();
		if (obj.type == "folder") {

		} else {
			this.selectOffer(obj, ev);
		}
	}


	selectOffer(_offer, ev?, isBeforeSummary?) {
		if (ev) ev.stopPropagation();
		if (this.$storage.menuDisabled) return;
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("MESSAGES.ITEM_OUT_OF_STOCK_MESSAGE", { name: _offer.name }) });
			return;
		}
		this.orderService.validateOrderLimit(1, _offer.price).then(() => {

			/*
			if (_offer._proccesdAdd) {
				let newOffer = _.cloneDeep(_offer);
				delete newOffer._reserved;
				newOffer._bid = this.orderUtils.getObjectId();
				newOffer.quantity = 1;
				this.orderUtils.animateAddToBasket(`#cat_${_offer._id}`, null, true).then(o => {
					this.orderService.addToBasket(newOffer);
				});
				return;
			}
			*/

			let enableQuickAdd = _offer.enableQuickAdd && !_offer._offer?.forceOfferEdit;
			if (!isBeforeSummary && _offer.offerBundle) {
				if (!_offer.offerBundle._prepared) this.orderUtils.prepareOfferBundles(_offer, this.$storage);
				if (_offer.preSale) {
					_offer.preSale.enableQuickAdd = enableQuickAdd;
					this.orderDialogs.openOfferBundleDialog(this.$storage, _offer.preSale, 'presale').then(result => {
						if (!this.$storage.order || _offer.preSale.requirePreSelection) return;
						if (!result || !result["viewItem"]) {
							if (!enableQuickAdd && _offer._enableEdit) {
								this.editOfferClick(_offer, isBeforeSummary);
							} else {
								this.selectQuickOffer(_offer);
							}
						}
					});
					return;
				}
			}

			if (!enableQuickAdd) { // && (_offer._enableEdit )
				this.editOfferClick(_offer, isBeforeSummary);
			} else {
				this.selectQuickOffer(_offer);
			}

		}).catch(err => {
			if (err && err.type == 'orderLimit') this.showSummary();
		});
	}

	selectQuickOffer(_offer, isBeforeSummary?) {
		if (_offer._disabled) {
			this.appService.alert({ content: this.appService.translate("MESSAGES.ITEM_OUT_OF_STOCK_MESSAGE", { name: _offer.name }) });
			return;
		}
		let viewItem = _.cloneDeep(_offer);
		if (_offer.isBasketOffer) {

		} else {
			this.orderUtils.prepareViewItem(this.$storage.catalog, viewItem);
			this.orderUtils.prepareSelectItem(this.$storage.catalog, viewItem);

			if (!this.orderUtils.validateOffer(viewItem)) {
				this.editOffer(_offer, isBeforeSummary);
				return;
			}

			if (_offer.isWeight && _offer.baseUnits) {
				viewItem.total = viewItem.viewPrice;
			} else {
				viewItem.total = viewItem.price;
				if (viewItem._item && viewItem._item._addPrice) {
					viewItem.total += viewItem._item._addPrice;
				}
			}
			viewItem.quantity = 1;
		}

		this.orderUtils.animateAddToBasket(`#cat_${_offer._id}`, null, true).then(o => {
			this.orderService.addToBasket(viewItem);
			this.appService.toastr(this.appService.translate('TO.offer_added_toast', { val: _offer.name }), { type: 'info', duration: 3000 });

			if (isBeforeSummary) this.showSummary();
			else if (_offer.upsaleGroup) this.openUpsaleGroup(_offer.upsaleGroup, 'up-sale');

			/*
			else if (_offer.upsaleGroup) {
				this.openUpsaleGroup(_offer.upsaleGroup);
			}
			*/
		});
	}

	editOfferClick(_offer, isBeforeSummary?) {
		this.openOfferDialog(_offer, isBeforeSummary);
	}

	editOffer(_offer, isBeforeSummary?) {
		this.openOfferDialog(_offer, isBeforeSummary);
	}

	openOfferDialog(_offer, isBeforeSummary?) {
		this.orderDialogs.openOfferDialog(_offer).then(result => {
			if (result) {
				this.orderUtils.animateAddToBasket(`#cat_${_offer._id}`, _.get(result, 'viewItem.total'), true).then(o => {
					this.orderService.addToBasket(result["viewItem"]);
					this.orderService.$storage.basket.length == 3;
					if (!isBeforeSummary && _offer.upsaleGroup) this.openUpsaleGroup(_offer.upsaleGroup, 'up-sale');
				});
			}
			if (isBeforeSummary) this.showSummary();
		});
	}

	gotoSummary() {
		if (!this.$storage.basket.length) {
			this.appService.alert({ content: this.appService.translate("no_basket_items") });
			return;
		}
		if (this.orderService.getMaxRemainingItems() == 0) this.showSummary();
		else {
			let upsaleGroups = this.orderService.getUpsaleGroups('beforeCheckout');
			this.openUpsaleGroups(upsaleGroups, 0, 'summary', true);
		}
	}

	openUpsaleGroups(groups, index, mode?, isBeforeSummary?) {
		let upsaleGroup = groups[index];
		if (!upsaleGroup) {
			switch (mode) {
				case "summary":
					this.showSummary();
					break;
			}
			return;
		}
		this.orderDialogs.openOfferBundleDialog(this.$storage, upsaleGroup, mode).then((result: any) => {
			if (result && result.wasOfferSelected && isBeforeSummary) {
				this.orderUtils.animateAddToBasket().then(() => {
					return this.showSummary();
				});
			} else {
				this.openUpsaleGroups(groups, ++index, mode, isBeforeSummary);
			}
		});
	}
	openUpsaleGroup(upsaleGroupId, mode) {
		//if (this.orderService.getMaxRemainingItems() == 0) return;
		let upsaleGroup = this.orderService.getUpsaleGroup(upsaleGroupId);
		if (!upsaleGroup || !upsaleGroup.active) return;
		this.orderDialogs.openOfferBundleDialog(this.$storage, upsaleGroup, mode).then(result => { });
	}

	showSummary() {
		if (!this.$storage.basket.length) {
			this.appService.alert({ content: this.appService.translate("no_basket_items") });
			return;
		}
		this.checkout.emit();
	}

	// ------------------------------------------------------------------------------->
	// navigation
	// ------------------------------------------------------------------------------->

	categoryIndex: number = 0;
	activeSubCat: any = null;
	tabIndex: number = 0;
	currentSection;
	scrollMatchTimeout = null;

	menuBackClick(obj) {
		if (!obj) return;
		this.$storage.activeSubCat = this.activeSubCat = obj.parentSubCat;
		this.tabIndex = obj.parentTabIndex
	}

	menuCatClick(menu, catIndex?) {
		//this.orderUtils.popCatMessage(this.$storage, menu).then(() => {
			let catId = menu._id;
			this.$storage.activeSubCat = this.activeSubCat = null;
			if (this.tabIndex != 0) {
				this.categoryIndex = this.tabIndex = 0;
				setTimeout(() => { this.menuCatScroll(catId); }, 300)
			} else {
				this.menuCatScroll(catId);
			}

		//});
	}

	private mapTabToScroll = {};

	menuSubfolderClick(obj, ev?) {
		this.orderUtils.popCatMessage(this.$storage, obj).then(() => {
			this.mapTabToScroll[this.tabIndex] = this.getScrollParent(ev.target);
			let targetFolder = _.find(this.$storage.catalog.folders, { _id: obj._id });
			if (targetFolder) {
				this.currentSection = obj.parentId;
				targetFolder.parentTabIndex = this.tabIndex;
				targetFolder.parentSubCat = this.activeSubCat;
				this.$storage.activeSubCat = this.activeSubCat = targetFolder;
				this.tabIndex = targetFolder.tabIndex;
			}
		});
	}

	onSelectedTabChange(tabChange) {
		let index = tabChange.index;
		if (this.mapTabToScroll[index]) {
			$("._scrollable").scrollTop(this.mapTabToScroll[index]);
			// restore scroll to mapTabToScroll[currentTabIndex] value
		}
	}

	getScrollParent(element) {
		for (var parent = element; (parent = parent.parentElement);) {
			if (parent.classList.contains('mat-tab-body-content')) return parent.scrollTop;
			else if (parent.scrollTop > 0) return parent.scrollTop;
		}
	}

	// ------------------------------------------------------------------------------->
	// scroll spy
	// ------------------------------------------------------------------------------->

	onSectionChange(section: string) {
		if (section == 'userOffers') {
			let oo = 123
		}
		let hTarget = document.getElementById(`nav_${section}`);
		if (hTarget && section != this.currentSection) {
			clearTimeout(this.scrollMatchTimeout);
			this.currentSection = section;
			this.scrollMatchTimeout = setTimeout(() => {
				//$('#menu_nav_container').stop().animate({ scrollLeft: hTarget.scrollLeft }, 200, 'swing', () => { });
				hTarget.focus();
				//hTarget.scrollIntoView({ inline: "center" });
			}, 300);
		}
	}


	menuCatScroll(section) {
		const hSection = document.getElementById(`${section}`);
		if (!hSection) return;
		$(`#nav_${section}`).addClass("pressed");

		const newScrollTop = hSection.offsetTop - 60;
		$('#main-tab-scroll-content').stop().animate({ scrollTop: newScrollTop }, 200, 'swing', () => {
			$(`#nav_${section}`).removeClass("pressed");
		});

		//mainTabScrollContent.scrollTo({
		//	behavior: newScrollTop > currentScrollTop ? 'smooth': 'instant',
		//	top: newScrollTop
		//});
	}

	topHeaderClick() {

	}

	searchCatalog(): Promise<any> {
		return new Promise((resolve, reject) => {
			const enableChatBot = !this.$storage.menuDisabled && this.$storage.catalog?.enableTabot;
			const component:ComponentType<any> = enableChatBot ? ChatSearchDialogComponent : OfferSearchDialogComponent;
			let dialogRef = this.dialog.open(component, {
				direction: this.appService.direction,
				autoFocus: false,
				panelClass: 'fullscreen-dialog',
				data: {}
			});
			dialogRef.afterClosed().subscribe(result => {
				if (result) {
					if (enableChatBot) {
						resolve(result);
					} else {
						if (this.$storage.menuDisabled) return;
						this.menuItemClick(result.offer, result.ev);
					}
				}
			});
		});
	}
	async onBannerClick(banner) {
		switch (banner.actionType) {
			case "category":
				const category = this.$storage.catalog.view.find(o => o._id === banner.actionCategory);
				if (category) {
					this.menuCatClick(category);
				}
				break;
			case "offer":
				if (!this.orderService.catalogItemsAsFlatArray) this.orderService.getCatalogItemsAsFlatArray();
				const offer = this.orderService.catalogItemsAsFlatArray.find(o => o.offer === banner.actionOffer);
				if (offer) {
					this.menuItemClick(offer);
				}
				break;
			case "registration":
				if (!this.appService.user) {
					const loginResponse = await this.dialogsService.login({}, 'tabitOrder');
				}
				break;
			case "externalURL":
				window.open(banner.actionURL, '_blank');
				break;
		}
	}
}
